export const locationStations = (state, rootState, getters, rootGetters) => locationId => {
  return rootGetters['entities/Station'](station => {
    if (station.location) {
      return station.location.id === locationId;
    }
  }).sort((a, b) => a.order - b.order);
};
